import React from "react"

const TMPButton = (props) => <button
    className={"btn btn-primary w-md " + props.extraClassName} {...props}>{props.children}</button>

export default TMPButton